import Scalar from "src/libs/scalars/scalars/Scalar"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import ExternalUpdateHandler from "../../views/landing/primitive/links-feed/ExternalUpdateHandler"
import { ILanding } from "../../data/interfaces"
import { ILandingStore, useLandingStore } from "../../data/store"

/* Protopia Ecosystem component */
export interface IExternalLinksFeedScalarProps extends ICompositeWidgetProps {
   
}
const ExternalLinksFeedScalar = (props: IExternalLinksFeedScalarProps): JSX.Element => {
    return <>
            <Scalar 
                title={props.title}
                subtitle={props.subtitle}
                value={props.value}
                editable={props.editable}
                notClear
                enabledForm={<ExternalLinksFeedEnabled {...props}  />}  
                desabledForm={<ExternalLinksFeedEnabled {...props} />}  
                subMenus={props.subMenus}
                onSubMenu={props.onSubmenu} 
            />
        </>
}
export default ExternalLinksFeedScalar

const ExternalLinksFeedEnabled = (props: IExternalLinksFeedScalarProps): JSX.Element => {
    const currentLanding: ILanding = useLandingStore((state:ILandingStore) => state.currentLanding )
    const section = currentLanding.sections.find( sec => sec.id === props.origin?.sectionId )
    
    console.log( props.origin )
    
    return <div className="p-3">
        <div className="lead"> 
            <ExternalUpdateHandler 
                primitive={ props.origin } 
                section={ section } 
            />
        </div> 
    </div>
}